module.exports = __webpack_public_path__ + "img/cover1.2afd0d1d.png";